// Translate each row's track horizontally based on the section's progress
// through the viewport. data-direction="left" drifts the track left as the
// user scrolls down; "right" drifts it right. Disabled when reduced motion
// is preferred.
export default function initScrollingImageGallery() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const sections = document.querySelectorAll('[data-scrolling-image-gallery]');
    if (!sections.length) return;

    sections.forEach((section) => {
        const rows = section.querySelectorAll('.scrolling-image-gallery__row');
        if (!rows.length) return;

        let ticking = false;

        const update = () => {
            ticking = false;
            const rect = section.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight;
            // Progress: 0 when the section enters the bottom of the viewport,
            // 1 when it leaves the top. Clamped.
            const scrollable = Math.max(1, rect.height + vh);
            const raw = (vh - rect.top) / scrollable;
            const progress = Math.min(1, Math.max(0, raw));

            rows.forEach((row) => {
                const track = row.querySelector('[data-scrolling-image-gallery-track]');
                if (!track) return;
                const direction = row.getAttribute('data-direction') === 'right' ? 1 : -1;
                const travel = Math.max(0, track.scrollWidth - row.clientWidth);
                // Start each row offset so it visibly drifts across the viewport.
                const offset = direction === 1 ? -travel : 0;
                const x = offset + direction * progress * travel;
                track.style.transform = `translate3d(${x}px, 0, 0)`;
            });
        };

        const onScroll = () => {
            if (!ticking) { ticking = true; requestAnimationFrame(update); }
        };

        update();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
    });
}
